import React, { memo } from 'react';
import HintWrapper from '../HintWrapper';
import './BibleBooksHint.scss';

const BibleBooksHint = memo(({ attemptsCount, currentBook, gameWon, isHintRevealed, onRevealHint }) => {
  return (
    <HintWrapper
      attemptsCount={attemptsCount}
      currentItem={currentBook}
      gameWon={gameWon}
      isHintRevealed={isHintRevealed}
      onRevealHint={onRevealHint}
      cssPrefix="bible-books-game"
      hintProperty="verse"
      hintLabel="Key Verse"
      showPostWinHint={true}
      unlockThreshold={5}
    >
      {/* Custom content renderer for verse */}
      {currentBook && currentBook.verse && (
        <>
          <div><strong>Key Verse:</strong></div>
          <div className="bible-books-game__hint-verse-text">"{currentBook.verse}"</div>
        </>
      )}
    </HintWrapper>
  );
});

export default BibleBooksHint;